import { QuoteEditorPreviewRoot } from 'modules/Cube/view/layouts/quote/QuoteEditorPreview/QuoteEditorPreviewRoot'
import { useQuoteEditorPreviewConnector } from 'modules/Cube/view/layouts/quote/QuoteEditorPreview/useQuoteEditorPreview.connector'

export const QuoteEditorPreviewRoute = () => {
  const context = useQuoteEditorPreviewConnector()
  return <QuoteEditorPreviewRoot {...context} />
}
